import { render, staticRenderFns } from "./ScheduleCard.vue?vue&type=template&id=30f527f1"
import script from "./ScheduleCard.vue?vue&type=script&lang=js"
export * from "./ScheduleCard.vue?vue&type=script&lang=js"
import style0 from "./ScheduleCard.vue?vue&type=style&index=0&id=30f527f1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports